import React, { useEffect, useState } from 'react';
import { Card, Col, Form, Input, Row, Spin } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { withRouter, Prompt } from 'dva/router';
import { ButtonBar } from '../../../components';
import styles from './../styles.less';

const CategoryItem = (props) => {
  const [isSubmitted, setState] = useState(false);
  const id = props.match.params.categoryId;

  useEffect(() => {
    props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.Categories.List.Title',
        description: 'Component.Categories.List.Info',
      },
    });
    if (id) {
      props.dispatch({
        type: 'categories/getCategoryById',
        payload: { id },
      });
    }
  }, []);

  const cancelAction = () => {
    props.dispatch({
      type: 'app/goToRoute',
      payload: { routeName: 'CATEGORIES_LIST' },
    });
  };

  const handleSubmit = () => {
    props.form.validateFieldsAndScroll((error, values) => {
      if (!error) {
        const { name } = values;
        props.dispatch({
          type: `categories/${id ? 'update' : 'create'}`,
          payload: { id, name },
        });
        setState(true);
      }
    });
  };

  return (
    <Spin spinning={props.loading.models.categories}>
      <Prompt
        when={props.form.isFieldsTouched() && !isSubmitted}
        message={props.intl.locale}
      />
      <div className={styles.containerLarge}>
        <Form onSubmit={handleSubmit} className={styles.editForm}>
          <Card>
            <Row>
              <Col span={24}>
                <Form.Item label={<FormattedMessage id="Component.Categories.Edit.CatName" />}>
                  {props.form.getFieldDecorator('name', {
                    initialValue: props.categories.categoriesList.name || '',
                    rules: [{
                      required: true,
                      message: props.intl.formatMessage({ id: 'Common.Field.Required' }),
                    }],
                  })(
                    <Input maxLength={255} />,
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <ButtonBar cancelAction={() => cancelAction()} />
        </Form>
      </div>
    </Spin>
  );
};

export default withRouter(connect(
  ({ categories, loading }) => ({ categories, loading }),
)(Form.create()(injectIntl(CategoryItem))));



// WEBPACK FOOTER //
// ./src/components/Categories/CategoryItem/CategoryItem.js